import cloneDeep from "lodash.clonedeep";

const TYPE_OBJECT = "object";
const TYPE_PLAIN_OBJECT = "[object Object]";
const TYPE_ARRAY = "[object Array]";
const TYPE_STRING = "[object String]";
const TYPE_DATE = "[object Date]";

/**
 * @class Utils
 */
class Utils {

    static isArray(obj: any): boolean {
        return typeOf(obj) === TYPE_ARRAY;
    }

    static isObject(obj: any): boolean {
        return obj && typeof (obj) === TYPE_OBJECT;
    }

    static isPlainObject(obj: any): boolean {
        return typeOf(obj) === TYPE_PLAIN_OBJECT;
    }

    static isString(obj: any): boolean {
        return typeOf(obj) === TYPE_STRING;
    }

    static isDate(obj: any) {
        return typeOf(obj) === TYPE_DATE;
    }

    static isEmptyObject(obj?): boolean {
        if (!Utils.isPlainObject(obj)) {
            return true;
        }

        for (const prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    }

    static deepMerge(baseHash, priorityHash) {
        // TODO: [JF] 07/19/2016 - we should investigate why this
        //       function has the special cases so we can replace
        //       with a better implementation (e.g. lodash.cloneDeep)

        if (!baseHash) {
            return JSON.parse(JSON.stringify(priorityHash));
        }
        if (!priorityHash) {
            return JSON.parse(JSON.stringify(baseHash));
        }

        // clone base hash
        const mergedHash = cloneDeep(baseHash);
        if (baseHash.streams) {
            mergedHash.streams = baseHash.streams;
        }

        for (const key in priorityHash) {
            if (!priorityHash.hasOwnProperty(key)) {
                continue;
            }

            if (key in mergedHash) {
                if (typeof mergedHash[key] === "object") {
                    mergedHash[key] = this.deepMerge(mergedHash[key], priorityHash[key]);
                    continue;
                }
            }
            mergedHash[key] = priorityHash[key];
        }

        return mergedHash;
    }

    static filterEmptyValues(sourceObject) {
        if (!Utils.isPlainObject(sourceObject)) {
            return sourceObject;
        }

        return Object.keys(sourceObject).reduce((tmp, key) => {
            const value = sourceObject[key];
            if (Utils.isString(value)) {
                if (value.trim() !== "") {
                    tmp[key] = value;
                }
            } else if (typeof value === "boolean" || typeof value === "number") {
                tmp[key] = value;
            } else if (value) {
                tmp[key] = value;
            }
            return tmp;
        }, {});
    }
}

function typeOf(obj: any): string {
    return Object.prototype.toString.call(obj);
}

export default Utils;
